import React from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import {Block} from '../../styles/commons';
import PortalMessageCenter from '../PortalMessageCenter/PortalMessageCenter'


const MessageScreen = props => {
  const {match:{params:{sofId}={}}={}} = props;

  return (
    <Layout product='portal'>
      <PageHeader title='DreamEx Connect Messaging' />
      <Block>
        <PortalMessageCenter destinationId={sofId}/>
      </Block>
    </Layout>
  );
};

export default MessageScreen;
